import { Component } from '@angular/core';
import { LoaderService } from '../../services/loader.service';

@Component({
  selector: 'app-loader-main',
  templateUrl: './loader-main.component.html',
  styleUrls: ['./loader-main.component.scss']
})
export class LoaderMainComponent {
 isLoading = this.loaderService.loading$;

  constructor(private loaderService: LoaderService) {}
}
